import { Routes, Route } from "react-router-dom";
import { ChatApp } from "../../chat";


export default function Assistant() {
  return (
    <div className="flex h-full w-full bg-background-100 dark:bg-background-900">
      {/* Navbar & Main Content */}
      <div className="bg-background-600 h-full w-full font-dm dark:bg-navy-900">
        <Routes>
          <Route
            path="/"
            element={<ChatApp />}
          />
          <Route
            path="/:agentId"
            element={<ChatApp />}
          />
          <Route
            path="/:agentId/:threadId"
            element={<ChatApp />}
          />
        </Routes>
      </div>
    </div>
  );
}
